import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'formattedDateTime',
    standalone: true
})
export class FormattedDateTimePipe implements PipeTransform {

    transform(dateString: string | null | undefined): string {
        if (!dateString) {
            return '\u2014';
        }
        return new Date(dateString + 'Z').toLocaleString(undefined, {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: 'numeric',
            minute: '2-digit',
            hour12: true,
            timeZoneName: 'short'
        }).replace(', ', ' at ');
    }

}
